import React from 'react';
const newContext = React.createContext(null);

export default newContext;